module.exports = function (res) {
  var p1 = "".concat(res.attacker_faction, " will roll ").concat(res.attacker_debater_power, " + ").concat(res.attacker_debater_bonus);
  var p2 = "".concat(res.defender_faction, " will roll ").concat(res.defender_debater_power, " + ").concat(res.defender_debater_bonus);
  var p3 = "".concat(res.attacker_faction, " rolls ").concat(JSON.stringify(res.adice));
  var p4 = "".concat(res.defender_faction, " rolls ").concat(JSON.stringify(res.ddice));
  var title = "ROUND ".concat(res.round, "<p></p>").concat(p1, "<p></p>").concat(p2, "<p></p>( hits on 5 and 6 )");
  if (res.adice.length) {
    title = "ROUND ".concat(res.round, "<p></p>").concat(p3, "<p></p>").concat(p4);
  }
  var html = "\n     <div class=\"theological-debate-overlay\" id=\"theological-debate-overlay\">\n        <div class=\"title\">".concat(title, "</div>\n        <div class=\"attacker_debater\"></div>\n        <div class=\"defender_debater\"></div>\n      </div>\n  ");
  return html;
};